<div class="ai-preset-dialog-container">
	<div class="d-flex justify-content-between align-items-center">
		<span class="title" mat-dialog-title>{{ (isEdit ? 'SETTINGS.AI_PRESET.EDIT' : 'SETTINGS.AI_PRESET.CREATE') | translate }}</span>
		<button mat-icon-button (click)="cancel()" class="d-flex justify-content-center align-items-center me-4">
			<mat-icon>close</mat-icon>
		</button>
	</div>

	<mat-dialog-content class="m-0 p-3">
		<form [formGroup]="form" (ngSubmit)="save()">
			<div class="row">
				<mat-form-field class="w-100 pb-2">
					<mat-label>{{ 'SETTINGS.AI_PRESET.TYPE' | translate }}</mat-label>
					<mat-select formControlName="type">
						@for (type of typeOptions; track type) {
						<mat-option [value]="type">{{ type }}</mat-option>
						}
					</mat-select>
				</mat-form-field>
			</div>

			<div class="row">
				<mat-form-field class="w-100 pb-2">
					<mat-label>{{ 'SETTINGS.AI_PRESET.PROVIDER' | translate }}</mat-label>
					<mat-select formControlName="provider">
						@for (provider of providerOptions; track provider) {
						<mat-option [value]="provider">{{ 'SETTINGS.AI_PRESET.PROVIDERS.' + provider | translate }}</mat-option>
						}
					</mat-select>
				</mat-form-field>
			</div>

			<div class="row">
				<mat-form-field class="w-100 pb-2">
					<mat-label>{{ 'SETTINGS.AI_PRESET.MODEL' | translate }}</mat-label>
					<input matInput formControlName="model" placeholder="gpt-4o-mini" />
				</mat-form-field>
			</div>

			<div class="row">
				<mat-form-field class="w-100 pb-2">
					<mat-label>{{ 'SETTINGS.AI_PRESET.PROMPT' | translate }}</mat-label>
					<textarea matInput formControlName="prompt" rows="12"></textarea>
				</mat-form-field>
				@if (requiredPlaceholders.length) {
				<div class="placeholder-pills">
					@for (name of requiredPlaceholders; track name) {
					<span class="placeholder-pill" [class.active]="isPlaceholderPresent(name)">{{ '{' + name + '}' }}</span>
					}
				</div>
				}
			</div>
		</form>
	</mat-dialog-content>

	<mat-dialog-actions [align]="'end'" class="pe-4">
		<mat-divider class="w-100 my-2"></mat-divider>
		<div class="gap-2 d-flex justify-content-end pt-0">
			<button mat-flat-button type="button" color="primary" (click)="save()" [disabled]="form.invalid || saving || !allPlaceholdersPresent">
				{{ 'BUTTON.SAVE' | translate }}
			</button>
			<button mat-flat-button type="button" color="primary" (click)="cancel()">
				{{ 'BUTTON.CANCEL' | translate }}
			</button>
		</div>
	</mat-dialog-actions>
</div>
